import React from 'react';
import { PresentationIcon, UsersIcon, SchoolIcon, BrainIcon, MessageSquareIcon, SmartphoneIcon } from 'lucide-react';
import { audience } from '../data/landing';
const iconMap: Record<string, React.ElementType> = {
  docente: PresentationIcon,
  tutor: UsersIcon,
  equipo: SchoolIcon,
  orientador: BrainIcon,
  profesional: MessageSquareIcon,
  digital: SmartphoneIcon
};
export function AudienceSection() {
  return <section className="w-full bg-cream px-4 py-11 sm:px-8 sm:py-16" data-id="element-1" data-mp="3viwbu2azl1cq">
      <div className="mx-auto max-w-6xl" data-id="element-2" data-mp="4a8qhmcqxe56">
        <h2 className="font-display text-2xl font-extrabold leading-tight text-ink-900 sm:text-4xl" data-id="element-3" data-mp="48xkrgzqpwbf">
          ¿Para quién es este Mega Pack?
        </h2>

        <ul className="mt-5 grid grid-cols-2 gap-x-4 gap-y-5 sm:mt-8 sm:gap-6 lg:grid-cols-3" data-id="element-4" data-mp="e1398gqs9vlv">
          {audience.map(item => {
          const Icon = iconMap[item.icon] ?? UsersIcon;
          return <li key={item.titulo} className="flex h-full flex-col" data-id="element-5" data-mp="3holrry9xpvd0">
                <Icon className="h-5 w-5 text-gold-600 sm:h-7 sm:w-7" strokeWidth={1.7} aria-hidden="true" data-id="element-6" data-mp="14bc41aclo24z" />
                <h3 className="mt-2 font-display text-sm font-bold leading-snug text-ink-900 sm:mt-4 sm:text-lg" data-id="element-7" data-mp="ukzm7pw66n2j">
                  {item.titulo}
                </h3>
                <p className="mt-1 font-sans text-xs leading-relaxed text-ink-700 sm:mt-2 sm:text-base" data-id="element-8" data-mp="qj5q7uwx678p">
                  {item.descripcion}
                </p>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}